import { createAppSlice } from "../../../store/createAppSlice";

export interface SystemMessageUiState {
  isOpen: boolean;
}

export interface SystemMessageState {
  // Keyed by an opaque owner id (a chat id today; any host's id later).
  byId: Record<string, SystemMessageUiState>;
}

const initialState: SystemMessageState = { byId: {} };

const systemMessageSlice = createAppSlice({
  name: "systemMessage",
  initialState,
  reducers: (create) => ({
    setOpen: create.reducer<{ id: string; isOpen: boolean }>((state, action) => {
      const { id, isOpen } = action.payload;
      state.byId[id] = { ...state.byId[id], isOpen };
    }),
  }),
  selectors: {
    getIsOpen: (state: SystemMessageState, id: string, defaultIsOpen: boolean): boolean =>
      state.byId[id]?.isOpen ?? defaultIsOpen,
  },
});

const { actions, selectors } = systemMessageSlice;

export { actions, selectors, systemMessageSlice };
